export const PRE_DEFINED_DATABASE_REACTIVATION_ROTATION_FILTER = [
    { label: 'Week 1: Likely to Default', value: 1},
    { label: 'Week 2: Tax Delinquent', value: 2},
    { label: 'Week 3: Vacant Out-of-State', value: 3},
    { label: 'Week 4: The Magic List', value: 4},
]